import { assert } from "./tools"

type CVSValue = string | number | boolean | Date | null | undefined

export class CSVHelper {
  readonly fileName: string
  private fileWriter?: FileSystemWritableFileStream
  private cachedCount = 0
  private cachedContent = ""
  readonly maxCachedCount = 10

  constructor(fileName: string) {
    this.fileName = fileName
  }

  async init(): Promise<boolean> {
    try {
      // 创建文件写入流
      const fd = await window.showSaveFilePicker({
        suggestedName: `${this.fileName}.csv`,
      })
      this.fileWriter = await fd.createWritable()
      return true
    } catch (e) {
      console.error("Failed to create file writer:", e)
      return false
    }
  }

  async writeHeader(header: string[]) {
    if (!this.fileWriter) {
      console.warn("File writer is not ready")
      return
    }

    await this.fileWriter.write({
      type: "write",
      data: this.convertToCSVRow(header) + "\n",
    })
  }

  writeData(data: CVSValue[]) {
    this.cachedContent += this.convertToCSVRow(data) + "\n"
    this.cachedCount++
    if (this.cachedCount >= this.maxCachedCount) {
      this.flush()
    }
  }

  finish() {
    this.flush()
    this.fileWriter?.close()
  }

  private flush() {
    assert(this.fileWriter !== undefined, "File writer is not ready")
    if (this.cachedCount > 0 && this.cachedContent.length > 0) {
      this.fileWriter.write({ type: "write", data: this.cachedContent })
      this.cachedContent = ""
      this.cachedCount = 0
    }
  }

  private convertToCSVRow(data: CVSValue[]): string {
    return data
      .map((v) => {
        if (v === null || v === undefined) {
          return ""
        }
        if (typeof v === "string") {
          return `"${v}"`
        }
        return v
      })
      .join(",")
  }
}
